export default function proxyContext(proxy, context) {
  const proto = Object.getPrototypeOf(context);
  proxy.ctx = Object.create(proto);
  Object.keys(context).forEach((key) => {
    if (typeof context[key] === 'function') {
      proxy.ctx[key] = context[key].bind(context);
    } else {
      proxy.ctx[key] = context[key];
    }
  });
  // pageTitle
  const nav = context.getCurrentPageNav();
  let { title } = nav;
  // 可能多语言的
  if (typeof title === 'object' && title && title.type === 'i18n') {
    const locale = context.getLocale();
    title = title[locale];
  }
  proxy.ctx.pageTitle = title;
}
